module.exports = (__webpack_require__(32395))(5915);